import { AdminConsentRequestPolicy } from '@microsoft/microsoft-graph-types-beta';
import { createAction, props } from '@ngrx/store';

export const loadAdminConsentRequestPolicy = createAction(
    '[Graph/admin Consent Request Policy] Load admin Consent Request Policy ',
    props<{ _tenant: string }>(),
);

export const loadAdminConsentRequestPolicySuccess = createAction(
    '[Graph/Domain] Load Admin Consent Request Policy Polciy Success',
    props<{
        _tenant: string;
        policy: AdminConsentRequestPolicy;
    }>(),
);

export const loadAdminConsentRequestPolicyFailure = createAction(
    '[Graph/Domain] Load Admin Consent Request Policy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateAdminConsentRequestPolicy = createAction(
    '[Graph/admin Consent Request Policy] Update Admin Consent Request Policy ',
    props<{ _tenant: string; data: AdminConsentRequestPolicy }>(),
);

export const updateAdminConsentRequestPolicySuccess = createAction(
    '[Graph/Domain] Update Admin Consent Request Policy Polciy Success',
    props<{ _tenant: string; data: AdminConsentRequestPolicy }>(),
);

export const updateAdminConsentRequestPolicyFailure = createAction(
    '[Graph/Domain] Update Admin Consent Request Policy Failure',
    props<{ _tenant: string; error: any }>(),
);
